import { Button } from "@/components/ui/button";
import { Upload, History, AlertCircle } from "lucide-react";
import { useState } from "react";
import { toast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";

interface CVActionButtonsProps {
  cvExists: boolean;
  showUploadZone: boolean;
  toggleUploadZone: () => void;
  isLoading: boolean;
  isAnalyzing: boolean;
  onTestAPI?: () => void;
  devMode?: boolean;
  testingAPI?: boolean;
  onViewHistory?: () => void;
  candidateName?: string;
  candidateId: string;
}

export const CVActionButtons = ({
  cvExists, 
  showUploadZone, 
  toggleUploadZone, 
  isLoading, 
  isAnalyzing,
  onTestAPI,
  devMode = false,
  testingAPI = false,
  onViewHistory,
  candidateName,
  candidateId
}: CVActionButtonsProps) => {
  const { t } = useTranslation();

  // Download functionality is removed for now

  return (
    <div className="flex flex-col gap-2 w-full">
      {cvExists && !showUploadZone && (
        <>
          {/* Download button has been removed */}
          {onViewHistory && (
            <Button 
              variant="outline" 
              size="sm" 
              onClick={onViewHistory}
              className="flex items-center gap-1"
            >
              <History className="h-4 w-4" />
              <span>{t("candidates.cv.history")}</span>
            </Button>
          )}
        </>
      )}
      <Button 
        variant="outline" 
        size="sm" 
        onClick={toggleUploadZone}
        disabled={isLoading || isAnalyzing}
      >
        {isAnalyzing ? t("candidates.cv.analyzing") : (cvExists ? t("candidates.cv.updateCV") : t("candidates.cv.uploadCV"))}
      </Button>
      {devMode && onTestAPI && (
        <Button
          variant="outline"
          size="sm"
          onClick={onTestAPI}
          disabled={testingAPI}
          className="flex items-center gap-1"
        >
          <AlertCircle className="h-4 w-4" />
          <span>{testingAPI ? t("candidates.cv.testing") : t("candidates.cv.testAPI")}</span>
        </Button>
      )}
    </div>
  );
};
